import { Alert, Box, Button, MenuItem, TextField } from "@mui/material";
import { useState } from "react";
import { updateLoginContacts } from "../services/adminService";
import { formatDate } from "../utils/dateUtils";
import AdminChangePasswordModal from "./AdminChangePasswordModal";
import ModalWindow from "./modal/ModalWindow";

export default function CustomerInfoModal({ selectedCustomer }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [email, setEmail] = useState(selectedCustomer.emailMfa || selectedCustomer.email || "");
  const [telefon, setTelefon] = useState(selectedCustomer.telefon || "");
  const [mfaTyp, setMfaTyp] = useState(selectedCustomer.mfaTyp || "EMAIL");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const saveLoginContacts = async () => {
    setMessage("");
    setError("");
    const result = await updateLoginContacts(
      selectedCustomer.cisloOdberatele,
      email.trim(),
      telefon.trim(),
      mfaTyp
    );
    if (result.success) setMessage("Přihlašovací údaje byly uloženy do rozšířené karty odběratele.");
    else setError(result.message || "Přihlašovací údaje se nepodařilo uložit.");
  };

  const readOnlyField = (label, value) => (
    <TextField label={label} value={value || "-"} fullWidth slotProps={{ input: { readOnly: true } }} />
  );

  return (
    <Box sx={{ mt: 2, display: "flex", flexDirection: "column", minWidth: 300, flexGrow: 1 }}>
      <Box sx={{ flex: 1, overflowY: "auto", p: 2, display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
        {readOnlyField("Číslo odběratele", selectedCustomer.cisloOdberatele)}
        {readOnlyField("Název", selectedCustomer.nazev)}
        {readOnlyField("Adresa", selectedCustomer.adresa)}
        {readOnlyField("IČ", selectedCustomer.ic)}
        {readOnlyField("DIČ", selectedCustomer.dic)}
        {readOnlyField("E-mail z Orsoftu", selectedCustomer.emailOrsoft)}
        {readOnlyField("Počet přihlášení", selectedCustomer.pocetPrihlaseni ?? "-")}
        {readOnlyField("Poslední přihlášení", selectedCustomer.posledniPrihlaseni ? formatDate(selectedCustomer.posledniPrihlaseni) : "-")}
        {readOnlyField("Registrovaný", selectedCustomer.jeRegistrovany ? "ANO" : "NE")}
      </Box>

      <Box sx={{ p: 2, borderTop: (theme) => `1px solid ${theme.palette.divider}` }}>
        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
          <TextField select label="Preferovaný typ MFA" value={mfaTyp}
            onChange={(event) => setMfaTyp(event.target.value)} fullWidth>
            <MenuItem value="EMAIL">E-mail</MenuItem>
            <MenuItem value="SMS">SMS</MenuItem>
          </TextField>
          {mfaTyp === "EMAIL" ? (
            <TextField label="E-mail pro MFA" type="email" value={email}
              onChange={(event) => setEmail(event.target.value)} fullWidth />
          ) : (
            <TextField label="Telefon pro MFA" value={telefon}
              onChange={(event) => setTelefon(event.target.value)} fullWidth />
          )}
          <Button variant="contained" onClick={saveLoginContacts}>Uložit přihlašovací údaje</Button>
        </Box>
      </Box>

      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <Button variant="contained" onClick={() => setModalVisible(true)}>Změnit heslo</Button>
      </Box>
      <ModalWindow visible={modalVisible} setVisible={setModalVisible}>
        <AdminChangePasswordModal cisloOdberatele={selectedCustomer.cisloOdberatele} setModalVisible={setModalVisible} />
      </ModalWindow>
    </Box>
  );
}
